//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'

import '@react/App.css'
import { BrowserRouter } from 'react-router-dom'
import AdminRouting from './AdminRouting'

import { LicenseInfo } from '@mui/x-license-pro'

import { ErrorBoundary } from '@react/components/ErrorBoundary'
import { useTheme } from '@mui/material'

LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

function AdminApp(): React.ReactElement {
  document.title = 'OpenTrade Admin'
  const theme = useTheme()

  return (
    <div
      className="App"
      style={{
        height: '100%',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.canvas,
        overflow: 'scroll',
      }}
    >
      <title>OpenTrade Admin </title>

      <BrowserRouter>
        <ErrorBoundary>
          <AdminRouting />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  )
}

export default AdminApp
